/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditionalNotesDto } from './AdditionalNotesDto';
import type { NutritionalGoalsDto } from './NutritionalGoalsDto';
import type { WeeklyMealPlanDto } from './WeeklyMealPlanDto';
export type UpdateDietPlanDto = {
    /**
     * Plan name
     */
    plan_name?: string;
    /**
     * Plan description
     */
    description?: string;
    /**
     * Duration in days
     */
    duration_days?: number;
    /**
     * Daily target calories
     */
    target_calories?: number;
    /**
     * Start date (YYYY-MM-DD)
     */
    start_date?: string;
    /**
     * Nutritional goals
     */
    nutritional_goals?: NutritionalGoalsDto;
    /**
     * Weekly meal plan (Mon-Fri required, Sat-Sun optional)
     */
    weekly_meal_plan?: WeeklyMealPlanDto;
    /**
     * Additional notes (allergies, preferences, special instructions)
     */
    additional_notes?: AdditionalNotesDto;
    /**
     * Plan status
     */
    status?: UpdateDietPlanDto.status;
};
export namespace UpdateDietPlanDto {
    /**
     * Plan status
     */
    export enum status {
        ACTIVE = 'active',
        COMPLETED = 'completed',
    }
}

